import Router from 'next/router'
import { useEffect } from 'react'

/**
 * @param {boolean} unSavedChanges
 * @param {Dispatch<SetStateAction<boolean>>} setIsConfirmationOpen
 */

const useConfirmOnRouteChanges = (unSavedChanges: boolean, callback: () => Promise<boolean>, state?: any) => {
  useEffect(() => {
    const routeChangeStart = async () => {
      if (unSavedChanges && (await callback())) {
        Router.events.emit('routeChangeError')
        Router.replace(Router, Router.asPath, { shallow: true })
        throw 'Abort route change.'
      }
    }

    // For reload handeling
    const message = 'Do you want to leave?'
    const beforeunload = (e: any) => {
      if (unSavedChanges) {
        e.preventDefault()
        e.returnValue = message
        return message
      }
    }

    window.addEventListener('beforeunload', beforeunload)
    Router.events.on('routeChangeStart', routeChangeStart)

    return () => {
      window.removeEventListener('beforeunload', beforeunload)
      Router.events.off('routeChangeStart', routeChangeStart)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unSavedChanges, state])
}

export default useConfirmOnRouteChanges

// import { useRouter } from "next/router";
// import { useCallback, useEffect, useState } from "react";

// const useBeforeUnload = (enabled: boolean) => {
// 	const handler = useCallback(
// 		(event: BeforeUnloadEvent) => {
// 			if (!enabled) {
// 				return;
// 			}

// 			event.preventDefault();
//       const message = "You have unsaved changes. Do you want to stay on and save changes?";
//       event.returnValue = message;
//       return message;
// 		},
// 		[enabled]
// 	);

// 	useEffect(() => {
// 		if (!enabled) {
// 			return;
// 		}

// 		window.addEventListener("beforeunload", handler);

// 		return () => window.removeEventListener("beforeunload", handler);
// 	}, [enabled, handler]);
// };

// export const useConfirmOnRouteChanges = (isDirty: boolean) => {
// 	const router = useRouter();

// 	const [showLeaveModal, setShowLeaveModal] = useState(false);
// 	const [pathname, setPathname] = useState<string | null>(null);

// 	useBeforeUnload(isDirty);

// 	const onRouteChangeStart = useCallback(
// 		(pathname: string) => {
// 			if (!isDirty) {
// 				return;
// 			}

// 			setShowLeaveModal(true);
// 			setPathname(pathname);
//       router.events.emit('routeChangeError');
// 			throw "Abort route change."
// 		},
// 		[isDirty]
// 	);

// 	const removeRouteChangeStart = useCallback(() => router.events.off("routeChangeStart", onRouteChangeStart), [router.events, onRouteChangeStart]);

// 	const handleUserChoice = useCallback(
// 		(leave: boolean) => async () => {
// 			setShowLeaveModal(false);

// 			if (!leave) {
// 				setPathname(null);
// 				return;
// 			}

// 			removeRouteChangeStart();

// 			if (pathname) {
// 				await router.push(pathname);
// 			}
// 		},
// 		[pathname, removeRouteChangeStart, router]
// 	);

// 	useEffect(() => {
// 		router.events.on("routeChangeStart", onRouteChangeStart);

// 		return removeRouteChangeStart;
// 	}, [onRouteChangeStart, removeRouteChangeStart, router.events]);

// 	return [showLeaveModal, handleUserChoice] as const;
// };
